import React from "react";
import { observer } from "mobx-react";
import { AlertSubscriptionUpdateStore } from "../../store";
import { AlertSubscriptionUpdateForm } from "./AlertSubscriptionUpdateForm";
import { ErrorDialog, ConfirmCancelDialog } from "../../../../common/controls";
import { SavingOverlay } from "../../../../common/controls/forms/SavingOverlay";
import { OutdatedAfterSaveNotice } from "../../../../common/controls/forms/OutdatedAfterSaveNotice";

export type AlertSubscriptionUpdateProps = {
  alertSubscriptionUpdateStore: AlertSubscriptionUpdateStore;
  showToolbox?: boolean;
  showSaveFooter?: boolean;
};

export const AlertSubscriptionUpdate: React.FC<AlertSubscriptionUpdateProps> =
  observer(
    ({ alertSubscriptionUpdateStore, showToolbox = true, showSaveFooter }) => {
      return (
        <>
          <SavingOverlay open={alertSubscriptionUpdateStore.isSaving} />
          <OutdatedAfterSaveNotice
            open={alertSubscriptionUpdateStore.savedButOutdated}
            onReload={() =>
              alertSubscriptionUpdateStore.reloadAlertSubscription()
            }
            reloadDisabled={alertSubscriptionUpdateStore.isProcessing}
          />
          <AlertSubscriptionUpdateForm
            alertSubscriptionUpdateStore={alertSubscriptionUpdateStore}
            alertRuleError={
              alertSubscriptionUpdateStore.errors.alertRule?.message
            }
            onAlertRuleChange={(value) => {
              alertSubscriptionUpdateStore.setAlertRuleValue(value);
            }}
            alertRuleSelectedValue={
              alertSubscriptionUpdateStore.entityValues.showAlertRule
            }
            onAlertRuleSelected={(value) => {
              alertSubscriptionUpdateStore.setSelectedAlertRule(value);
            }}
            alertRuleOptions={alertSubscriptionUpdateStore.getAlertRuleOptions()}
            enabledError={alertSubscriptionUpdateStore.errors.enabled?.message}
            onEnabledChange={(value: boolean) => {
              alertSubscriptionUpdateStore.setEnabledValue(value);
            }}
            enabled={alertSubscriptionUpdateStore.entityValues.enabled}
            showToolbox={showToolbox}
            showSaveFooter={showSaveFooter}
            saving={alertSubscriptionUpdateStore.saveDisabled}
            onSave={() => alertSubscriptionUpdateStore.saveAlertSubscription()}
            onCancel={() =>
              alertSubscriptionUpdateStore.cancelAlertSubscription()
            }
          />
          <ErrorDialog
            open={alertSubscriptionUpdateStore.errorDialogOpened}
            title={alertSubscriptionUpdateStore.errorTitle}
            description={alertSubscriptionUpdateStore.errorDescription}
            onClose={() => alertSubscriptionUpdateStore.closeErrorDialog()}
          />
          <ConfirmCancelDialog
            open={alertSubscriptionUpdateStore.confirmDialogOpened}
            title={alertSubscriptionUpdateStore.confirmDialogTitle}
            description={alertSubscriptionUpdateStore.confirmDialogDescription}
            onConfirm={() =>
              alertSubscriptionUpdateStore.executeConfirmedAction()
            }
            onCancel={() => alertSubscriptionUpdateStore.closeConfirmDialog()}
          />
        </>
      );
    }
  );
